import { render, staticRenderFns } from "./SimulationNew.vue?vue&type=template&id=48ee843f"
import script from "./SimulationNew.vue?vue&type=script&lang=ts"
export * from "./SimulationNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports